import PropTypes from 'prop-types';

import React from 'react';

import ReactDOM from 'react-dom';

import Spinner from 'spin.js';

class Loader extends React.Component {
  static defaultProps = {
    component: 'div',
    delayMS: 500,
  };

  static propTypes = {
    component: PropTypes.any,
    children: PropTypes.any,
    loaded: PropTypes.bool,
    options: PropTypes.object,
    scale: PropTypes.number,
    lines: PropTypes.number,
    length: PropTypes.number,
    width: PropTypes.number,
    radius: PropTypes.number,
    corners: PropTypes.number,
    rotate: PropTypes.number,
    direction: PropTypes.oneOf([1, -1]),
    color: PropTypes.string,
    speed: PropTypes.number,
    trail: PropTypes.number,
    shadow: PropTypes.bool,
    hwaccell: PropTypes.bool,
    className: PropTypes.string,
    zIndex: PropTypes.number,
    top: PropTypes.string,
    delayMS: PropTypes.number,
    left: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      loaded: !!props.loaded,
      options: {},
      delaying: !!props.delayMS,
    };
  }

  componentDidMount() {
    this.updateState(this.props);

    if (this.props.delayMS) {
      this.timeout = setTimeout(() => this.setState({delaying: false}, this.spin), this.props.delayMS);
    }
  }

  componentWillReceiveProps(nextProps) {
    const nextState = {...nextProps};

    if (nextState.loaded && !this.state.loaded) {
      nextState.delaying = false;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    } else if (!nextState.loaded && this.state.loaded) {
      nextState.delaying = true;
      this.timeout = setTimeout(() => this.setState({delaying: false}, this.spin), this.props.delayMS);
    }

    this.updateState(nextState, this.spin);
  }

  spin = () => {
    if (!this.state.loaded && !this.state.delaying) {
      let spinner = new Spinner(this.state.options);
      let target =  ReactDOM.findDOMNode(this.refs.loader);

      // Clear out any other spinners from previous renders
      target.innerHTML = '';
      spinner.spin(target);
    }
  };

  updateState = (props) => {
    props || (props = {});

    let loaded = this.state.loaded;
    let options = this.state.options;

    // Update loaded state, if supplied
    if ('loaded' in props) {
      loaded = !!props.loaded;
    }

    // Update spinner options, if supplied
    let allowedOptions = Object.keys(this.constructor.propTypes);

    allowedOptions.splice(allowedOptions.indexOf('loaded'), 1);
    allowedOptions.splice(allowedOptions.indexOf('options'), 1);

    // Allows passing options as either props or as an option object
    let propsOrObjectOptions = 'options' in props ? props.options : props;

    allowedOptions.forEach(key => {
      if (key in propsOrObjectOptions) {
        options[key] = propsOrObjectOptions[key];
      }
    });

    this.setState({loaded: loaded, options: options}, this.spin);
  };

  render() {
    let props, children;

    if (this.state.loaded) {
      props = {key: 'content', className: 'loadedContent'};
      children = this.props.children;
    } else if (this.state.delaying) {
      props = {key: 'delaying'};
    } else {
      props = {key: 'loader', ref: 'loader', className: 'loader'};
    }

    return React.createElement(this.props.component, props, children);
  }
}

export default Loader;
